<template>
  <div>
    <div class="container">
      <h1 class="title has-text-centered has-text-weight-bold">
        Create your new password
      </h1>
      <div class="columns is-centered">
        <div class="column is-one-third">
          <form id="forgotForm" @submit="submitForm($event)" novalidate>
            <div class="field">
              <label class="label" for="password">Password</label>
              <div class="control has-icons-left">
                <input
                  id="password"
                  required="required"
                  minlength="6"
                  maxlength="25"
                  name="password"
                  placeholder="Password"
                  :class="{ 'is-danger': !password.valid }"
                  class="input"
                  type="password"
                  v-model="newPassword"
                />
                <span class="icon is-small is-left">
                  <i class="fas fa-lock"></i>
                </span>
              </div>
              <p class="help" :class="{ 'is-danger': !password.valid }">
                {{ password.errorMessage }}
              </p>
            </div>
            <div class="field">
              <label class="label" for="confirmPassword">Confirm Password</label>
              <div class="control has-icons-left">
                <input
                  id="confirmPassword"
                  required="required"
                  name="confirmPassword"
                  placeholder="Confirm Password"
                  :class="{ 'is-danger': !confirmPassword.valid }"
                  v-model="confirmNewPassword"
                  class="input"
                  type="password"
                />
                <span class="icon is-small is-left">
                  <i class="fas fa-lock"></i>
                </span>
              </div>
              <p class="help" :class="{ 'is-danger': !confirmPassword.valid }">
                {{ confirmPassword.errorMessage }}
              </p>
            </div>
            <div class="field">
              <button
                type="submit"
                class="button is-fullwidth is-primary text-capitalize"
              >
                Change Password
              </button>
            </div>
          </form>
        </div>
        <div class="column is-one-third">
          <label class="label">Tips for a secure password</label>
          <ul>
            <li>
              Don't use a password you have used on sharedocview previously.
            </li>
            <li>Must use at least one letter.</li>
            <li>Must use at least one number.</li>
            <li>
              Don't use the same password for multiple online accounts.
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="modal" :class="{ 'is-active': modal.visible }">
      <div class="modal-background"></div>
      <div class="modal-card">
        <head class="modal-card-head">
          <p class="modal-card-title">{{ modal.header }}</p>
        </head>
        <section class="modal-card-body">
          <p class="has-text-centered">
            {{ modal.body }}
          </p>
        </section>
        <footer class="modal-card-foot">
          <button @click="redirect()" class="button is-primary">
            {{ modal.button }}
          </button>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      modal: {
        visible: false,
        header: '',
        body: '',
        button: '',
        login: false
      },
      newPassword: '',
      confirmNewPassword: '',
      password: {
        valid: true,
        errorMessage: ''
      },
      confirmPassword: {
        valid: true,
        errorMessage: ''
      }
    };
  },
  mounted() {},
  methods: {
    async submitForm(evt) {
      this.password.valid = true;
      this.confirmPassword.valid = true;
      evt.preventDefault();
      let form = this.$el.querySelector('#forgotForm');
      let fields = [
        {
          field: this.$el.querySelector('#password'),
          validation: this.password
        },
        {
          field: this.$el.querySelector('#confirmPassword'),
          validation: this.confirmPassword
        }
      ];
      if (fields[0].field.value !== fields[1].field.value) {
        form.valid = false;
        fields[1].field.valid = false;
        fields[1].validation.valid = false;
        fields[1].validation.errorMessage = 'Password fields must match';
        return;
      } else {
        form.valid = true;
        fields[1].field.valid = true;
        fields[1].validation.valid = true;
        fields[1].validation.errorMessage = '';
      }
      if (form.checkValidity()) {
        try {
          let response = await this.$axios.post(
            this.$API.forgotPass + this.$route.params.id,
            {
              password: this.newPassword,
              confirmPassword: this.confirmNewPassword
            }
          );
          if (response.status === 200) {
            this.modal.visible = true;
            this.modal.header = 'Great! Your new password has been saved';
            this.modal.body =
              'You can log in to sharedocview with your email address and your new password.';
            this.modal.button = 'Return to login';
            this.modal.login = true;
          }
        } catch (error) {
          this.modal.visible = true;
          this.modal.header = 'There was an error';
          this.modal.body = error.response.data;
          this.modal.button = 'Cancel';
        }
      } else {
        fields.forEach(function(fieldObject) {
          fieldObject.validation.valid = fieldObject.field.checkValidity();
          fieldObject.validation.errorMessage =
            fieldObject.field.validationMessage;
        });
      }
    },
    redirect() {
      if (this.modal.login) {
        return this.$router.push('/');
      }
      this.$router.push('/register');
    }
  }
};
</script>
<style lang="scss" scoped>
ul {
  li {
    margin: 15px;
    font-size: 14px;
    font-weight: normal;
  }
}
</style>
